import {
  GET_LOCATION_OPTION,
  GET_ROLE_OPTION,
  GET_POD_GROUP_OPTION,
  GET_TAG_OPTION,
  MARKET_INTEL_ROLE_OPTION,
  MARKET_INTEL_USER_OPTION
} from '../types';
const initialState = {
  locationOptions: [],
  roleOptions: {
    standardRole: [],
    subCategories: []
  },
  tags: [],
  podGroupOptions: []
};
export default function options(state = initialState, action = {}) {
  switch (action.type) {
  case GET_LOCATION_OPTION:
    // console.log("action data option", action.data);
    return {
      ...state,
      locationOptions: action.data
    };
  case GET_ROLE_OPTION:
    // console.log("action data option", action.data);

    //standardized role array
    // return { key, label, text} format
    let standardRole = action.data.map(role => {
      return {
        key: role._id,
        value: role.standardizedRole,
        text: role.standardizedRole
      };
    });

    return {
      ...state,
      roleOptions: {
        standardRole,
        subCategories: action.data
      }
    };

  case GET_TAG_OPTION:
    console.log('action data option', action.data);

    //standardized role array
    // return { key, label, text} format
    let standardTag = action.data.map((tag, key) => {
      return {
        key,
        value: tag,
        label: tag
      };
    });

    // console.log("standard role", standardRole);

    return {
      ...state,
      tags: standardTag
    };
  case GET_POD_GROUP_OPTION:
    console.log('pod options response', action.data);
    const { podGroups, users } = action.data;

    // Group users by their `pod_group`, excluding users with `pod_group` as null or undefined
    const groupedUsers = users.reduce((acc, user) => {
      if (user.pod_group) {
        // Only include users with a valid `pod_group`
        if (!acc[user.pod_group]) {
          acc[user.pod_group] = [];
        }
        acc[user.pod_group].push(user);
      }
      return acc;
    }, {});

    // Combine podGroups and grouped users
    const combinedPodGroups = podGroups.map(podGroup => ({
      podGroup,
      users: groupedUsers[podGroup] || [] // Include users for the pod group or an empty array if none exist
    }));

    console.log('pod options response', combinedPodGroups);

    return {
      ...state,
      podGroupOptions: combinedPodGroups
    };
  case GET_POD_GROUP_OPTION:
    // console.log("action data option", action.data);
    return {
      ...state,
      podGroupOptions: action.data
    };

  case MARKET_INTEL_ROLE_OPTION:
    // console.log("action data option", action.data);
    return {
      ...state,
      marketIntelRoleOptions: action.data
    };

  case MARKET_INTEL_USER_OPTION:
    // console.log("action data option", action.data);
    return {
      ...state,
      marketIntelCreatedByOptions: action.data
    };
  default:
    return state;
    break;
  }
}
